// Actions
export const PROFILE__UPDATE_BASIC_INFO = 'PROFILE__UPDATE_BASIC_INFO';
export const PROFILE__UPDATE_PAYMENT = 'PROFILE__UPDATE_PAYMENT';
export const PROFILE__UPDATE_PASSWORD = 'PROFILE__UPDATE_PASSWORD';
export const PROFILE__CONFIRM_EMAIL = 'PROFILE__CONFIRM_EMAIL';
export const PROFILE__UPDATE_NOTIFICATION_PREFERENCE = 'PROFILE__UPDATE_NOTIFICATION_PREFERENCE';
// Mutations
export const PROFILE__RESET = 'PROFILE__RESET';
export const PROFILE__MUTATE_LOADING_STATUS = 'PROFILE__MUTATE_LOADING_STATUS';
